module.exports = __webpack_public_path__ + "static/media/seerah2.e66c63a4.JPG";